.container {
    composes: container from '../../summary/summary.module.css';
    width: 320px;
}
